import React from "react";

const Footer = () => {
    return (
      <footer style={{ padding: '3rem 1.5rem' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ width: '2rem', height: '2rem', borderRadius: '0.5rem', backgroundColor: '#0055A4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.25rem' }}>F</span>
                </div>
                <span style={{ fontWeight: '500', fontSize: '1.25rem' }}>Fakeeh Care</span>
              </div>
              <p style={{ color: '#6B7280', marginTop: '1rem' }}>Advanced healthcare solutions that put patients first, connecting you with the right specialists for your needs.</p>
            </div>
            <div>
              <h3 style={{ fontWeight: '600', fontSize: '1.125rem', marginBottom: '1rem' }}>Services</h3>
              <ul>
                {['Primary Care', 'Specialty Care', 'Telehealth', 'Emergency Care', 'Preventive Care'].map((service) => (
                  <li key={service} style={{ marginBottom: '0.5rem' }}>
                    <a href="#" style={{ color: '#6B7280', textDecoration: 'none', transition: 'color 0.3s' }}>{service}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 style={{ fontWeight: '600', fontSize: '1.125rem', marginBottom: '1rem' }}>Company</h3>
              <ul>
                {['About Us', 'Careers', 'Blog', 'Press', 'Contact'].map((item) => (
                  <li key={item} style={{ marginBottom: '0.5rem' }}>
                    <a href="#" style={{ color: '#6B7280', textDecoration: 'none', transition: 'color 0.3s' }}>{item}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 style={{ fontWeight: '600', fontSize: '1.125rem', marginBottom: '1rem' }}>Stay Updated</h3>
              <p style={{ color: '#6B7280', marginBottom: '1rem' }}>Subscribe to our newsletter for the latest health tips and updates.</p>
              <div style={{ display: 'flex' }}>
                <input type="email" placeholder="Your email address" style={{ flex: 1, padding: '0.5rem', border: '1px solid #E5E7EB', borderRadius: '0.375rem 0 0 0.375rem', outline: 'none' }} />
                <button style={{ padding: '0.5rem 1rem', backgroundColor: '#0055A4', color: 'white', border: 'none', borderRadius: '0 0.375rem 0.375rem 0', cursor: 'pointer' }}>Subscribe</button>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '3rem', paddingTop: '1.5rem', borderTop: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <p style={{ color: '#6B7280', fontSize: '0.875rem' }}>© 2025 Fakeeh Care. All rights reserved.</p>
            <div style={{ display: 'flex', gap: '1.5rem', marginTop: '1rem' }}>
              {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((policy) => (
                <a key={policy} href="#" style={{ fontSize: '0.875rem', color: '#6B7280', textDecoration: 'none', transition: 'color 0.3s' }}>{policy}</a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    );
  };
  
  export default Footer;